import { inject, Provider } from '@angular/core';
import { ConfigService } from '@rxap/config';
import { isHeliaEnabled } from '../is-helia-enabled';
import { HeliaWorkerService } from './helia-worker.service';
import { IPFS_WORKER } from './ipfs-worker.token';

/**
 * Provides the dedicated Helia/IPFS worker. The worker is created lazily on
 * first injection of {@link HeliaWorkerService}, and only when Web Workers are
 * supported *and* IPFS is enabled (`ipfs.enabled !== false`) — so a deployment
 * with IPFS disabled spawns no worker at all (CID content falls back to HTTP
 * gateway fetch). By first injection, the runtime config has already loaded.
 *
 * Deliberately kept in the `shared/ipfs` folder — separate from
 * `shared/workers/provide.ts` — so that wiring it into the eager app config
 * does not pull that file's `@xenova/transformers`-backed worker imports into
 * the main bundle.
 */
export function provideIpfsWorker(): Provider[] {
  return [
    HeliaWorkerService,
    {
      provide: IPFS_WORKER,
      useFactory: () => {
        const config = inject(ConfigService);
        return typeof Worker !== 'undefined' && isHeliaEnabled(config)
          ? new Worker(new URL('../../shared/workers/ipfs.worker', import.meta.url))
          : null;
      },
    },
  ];
}
